<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile) + ' ' + formProperty.cssClass">
    <q-item tag="label" dense>
      <q-item-section avatar top> <!-- style="margin-top:-3px;padding-bottom:15px;" -->
        <q-checkbox bottom-slots true-value="1" false-value="0"
                    v-model="value" :autofocus="formProperty.autofocus" @update:model-value="onChange"
                    :hint="getHint()" hide-hint :disable="formProperty.readonly || readOnly" :readonly="formProperty.readonly || readOnly"
                    :toggle-indeterminate="formProperty.allowTristate" :indeterminate-value="3" toggle-order="tf"
                    :id="formProperty.nativename" :ref="formProperty.nativename" :dense="compressed"/>
      </q-item-section>
      <q-item-section>
        <q-item-label v-html="getTitle()"/>
        <q-item-label caption v-html="getHint()"/>
      </q-item-section>
    </q-item>
    <div v-if="propertyHasError" :style="{color: 'red', margin:getHint()===''?'-6px 0 10px 53px':'0px 0 10px 53px'}">{{ getErrorLabel() }}</div>

    <!--
        <div v-else class="roRow">
          <span class="roLabel" v-html="getTitle() + ':'"></span>
          <span class="roValue" v-html="value==1?'Ja':'Nein'"></span>
        </div>
    -->
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {requiredIf} from '@vuelidate/validators'
import {fldComponentsMixin} from './mixins/fldComponent'
import {StaticData} from 'src/classes/StaticData'
import {useAuthStore} from 'src/stores/AuthStore.js'
import {getValueOrCleanNull} from './formsHelper'

export default {
  mixins: [fldComponentsMixin],
  props: [
    'formProperty',
    'queryID',
    'volatile',
    'compressed',
    'readOnly'
  ],

  setup() {
    return {v$: useVuelidate()}
  },

  data() {
    return {
      StaticData,
      value: this.getValue()
    }
  },
  computed: {
    propertyHasError() {
      return (this.v$.value.$error && !this.v$.$errors.map(err => err.$validator).includes('requiredIf')) || this.formProperty.invalid
    }
  },
  validations() {
    return this.getValidations()
  },
  watch: {
    value: function () {
      if (this.value !== undefined && this.value != null) {
        this.formProperty.value = "" + this.value
      } else {
        this.formProperty.value = null
      }
    },
    formProperty: {
      handler: function (newVal) {
        this.value = newVal.value
      },
      deep: false
    }
  },
  methods: {
    getValidations() {
      let result = {value: {}}

      //console.log("validate number: min: ", this.formProperty.iValueMin, ", max: ", this.formProperty.iValueMax,
      //    ", lengthMin:", this.formProperty.lengthMin, ", lengthMax:", this.formProperty.iValueMax)

      result.value['requiredIf'] = requiredIf(() => {
        return this.checkRequired()
      })

      return result
    },
    checkRequired() {
      if (!this.formProperty.readonly && !this.readOnly) {
        if (this.formProperty.masterPropertyMode == StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
          return (this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY) && this.formProperty.showThroughDependency == true
        } else {
          return this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY
        }
      }
    },
    onChange(value) {
      this.formProperty.invalid = false
      this.v$.$touch()
      this.value = value
      this.formProperty.value = value

      // todo: only in formulars
      this.$emit('onChange', {classID: this.formProperty.classID, nativename: this.formProperty.nativename, deleteDependentFields: false, value: this.value})  // send onChange event to parent (formular or parameter)
      if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
        this.eventBus.formularEdited()
      }
    },
    getValue() {
      const authStore = useAuthStore()
      if (this.formProperty.nativename === "chkFinancialPlan") {
        console.log("checkbox getvalue")
      }

      let result = this.value ? this.value : this.formProperty.propertyInstanceValue // native value
      if(!result) result = false

      let propertyName = this.formProperty.name ? this.formProperty.name : this.formProperty.nativename
      let storedValue = localStorage.getItem(this.queryID + "__" + propertyName)
      let deepLinkParamValue = authStore.queryParamListFromDeepLink[this.formProperty.nativename]

      if (deepLinkParamValue) {
        // parameter value, given as request parameter (e.g.: qp.name), set in store in router beforeEach
        result = deepLinkParamValue

      } else if (storedValue != null && !this.formProperty.systemParameter) {
        result = getValueOrCleanNull(storedValue, this.formProperty)

      } else if (!this.formProperty.propertyInstanceValue && this.formProperty.defaultValue) {
        result = this.formProperty.defaultValue
      }

      // convert from typical boolean text names to 1 or 0
      let lresult = result

      if (result !== undefined && result != null) {
        lresult = ("" + result).toLowerCase()
      }

      if (lresult === "true" || lresult === "ja" || lresult === "1") result = "1"
      else if (lresult === "false" || lresult === "nein" || lresult === "0" || lresult === "") result = "0"
      else result = "3"

      this.formProperty.value = result
      return result
    },
    getErrorLabel() {
      let result = ""
      const errors = this.v$.$errors.map(err => err.$validator)
      if (errors.includes("requiredIf")) {
        result = this.formProperty.infoRequired && this.formProperty.infoRequired !== "" ? this.formProperty.infoRequired : "Feld muss befüllt werden."
      } else if (this.formProperty.invalid) {
        result = this.formProperty.errorMsg
      }
      return result
    },
    onRefreshComp(data) {
      if (this.formProperty.nativename === data.nativename && (data.subtypeCount === undefined || data.subtypeCount === this.formProperty.subtypeCount)) {
        // only refresh if we have data and it is not a staticTextField without SQL (which never can change)
        if (data.value && data.value.length > 0) {

          let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''
          //console.log("refresh, ", this.formProperty.fieldDependencies);

          // this component instance is a dependent field of changed field?
          if (myDepToken.includes(data.sourceChangedNativename)) {
            // console.log("string data.sourceChangedNativename:", this.formProperty.title, ", ", data.sourceChangedNativename, "==", myDepToken, ", value:", data.value)
            // console.log("!!! onRefreshComp of ", this.formProperty.title + " triggered.", this.formProperty.nativename, data.value, data.value.length)
            this.value = data.value
            this.formProperty.value = data.value

            if (data.errorMsg) this.formProperty.errorMsg = data.errorMsg
            else this.formProperty.errorMsg = ""
            if (data.errorFetchingData) this.formProperty.errorFetchingData = data.errorFetchingData
            else this.formProperty.errorFetchingData = ""

            if (data.errorMsg || data.errorFetchingData) this.formProperty.invalid = true
            else this.formProperty.invalid = false

            this.$forceUpdate()

            if (this.formProperty.instantRefresh &&
              // (this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency == true || this.formProperty.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE))) {
              (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {

              //console.log("cascade onChange ongoing from ", this.frmProperty.title)
              //console.log("emit onchange for ", this.formProperty.nativename)
              this.$emit('onChange', {
                classID: this.formProperty.classID,
                id: this.formProperty.ID,
                nativename: this.formProperty.nativename,
                deleteDependentFields: true,
                value: this.value
              })  // send onChange event to parent (formular or parameter)

            } else {
              this.showSpinner = false
            }
          }
        }
      }
    },
  },
  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshComp)
  },
  mounted: function () {
    this.eventBus.on('onRefreshComp', this.onRefreshComp)
    this.value = this.getValue()

    this.formProperty.validate = () => {
      this.v$.$reset()
      this.v$.$touch()
      this.formProperty.invalid = this.v$.value.$error
      if (this.checkRequired()) {
        if (this.value === "0") {
          this.formProperty.errorMsg = this.formProperty.infoRequired && this.formProperty.infoRequired != "" ? this.formProperty.infoRequired : "Feld muss befüllt werden."
          this.formProperty.invalid = true
        }
      }
      if (this.formProperty.errorFetchingData != "") {
        this.formProperty.errorMsg = this.formProperty.errorFetchingData
        this.formProperty.invalid = true
      }
    }

    this.formProperty.setValid = () => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // rerender field & errorstats
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
      this.v$.$touch()
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
      this.v$.$touch()
    }

    // Initial error? This can be if the field has SQL enabled content...
    if (this.formProperty.errorFetchingData && this.formProperty.errorFetchingData != "") {
      this.formProperty.setError(this.formProperty.errorFetchingData)
    }

    // send onChange event to parent (formular or parameter)
    //console.log("mount", !this.formProperty.noInitOnChange, this.formProperty.objInstanceID)

    if (!this.formProperty.noInitOnChange && !this.formProperty.objInstanceID) {
      this.$emit('onChange', {classID: this.formProperty.classID, nativename: this.formProperty.nativename, deleteDependentFields: false, value: this.value})
    }
  }
}
</script>

<style lang="sass">
.q-field-label
  font-weight: bold

//.q-field--dense .q-field__label
//  top: 6px

.q-field--dense
  font-size: 13px

.q-field--dense .q-field__bottom
  padding-top: 2px

.txtHint
  color: rgba(0, 0, 0, 0.54)
  font-size: 11px
  display: block
  margin-top: -1px
</style>
